import toString from 'lodash/toString';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';

export const DATA_AUTOMATION_ID = 'data-automation-id' as const;

/*
 ** value: string | number => string | null
 ** Used for converting arbitrary values to data-automation-id strings.
 ** Returns null if it cannot create a string
 */
export const getAutomationId: (value: string | number) => string = (value) => {
  const dataId = isString(value) || isNumber(value) ? toString(value) : '';
  return dataId;
};
